import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";

import { useAxios } from "../../../hooks";
import FormDisplay from "./FormDisplay";
import WorkflowNode from "./WorkflowNodes";
import { ButtonFooter } from "../../../components";
import { objectFromFormData } from "./workflowObject";
import { alert } from "../../../redux/slices/alertSlice";
import { useNavigate } from "react-router-dom";
import pages from "../../../constants/pages";

export default function Form({ formData, editState, setEditState }) {
  const axios = useAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { activeBot } = useSelector((state) => state.memberDetails);

  return (
    <Formik
      onSubmit={(formData, { setSubmitting }) => {
        axios({
          url:
            "/workflow/" + activeBot.ID + "?workflow_id=" + formData.workflowID,
          method: "POST",
          data: objectFromFormData(formData),
          disableRedirect: true,
        }).then((response) => {
          if (response.status) {
            navigate(pages.workflowList.route);
            dispatch(
              alert({
                type: "success",
                message: response.message.displayMessage,
              })
            );
          }

          setSubmitting(false);
        });
      }}
      enableReinitialize
      initialValues={formData}
      validateOnMount
    >
      {(formikProps) => (
        <form onSubmit={formikProps.handleSubmit}>
          <FormDisplay editState={editState} formikProps={formikProps} />
          <WorkflowNode editState={editState} formikProps={formikProps} />

          <ButtonFooter
            ID={formikProps.values?.workflowID}
            editState={true}
            setEditState={setEditState}
            formikProps={formikProps}
          />
        </form>
      )}
    </Formik>
  );
}
